import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Entry } from 'contentful';

import { EntryData } from '@src/app/shared/interfaces/entryData';

import { AnalyticsService } from '@src/app/shared/services/fb-analytics.service';

@Component({
  selector: 'app-related-entries',
  templateUrl: './related-entries.component.html',
  styleUrls: ['./related-entries.component.scss']
})

export class RelatedEntriesComponent {
  @Input() entries: Entry<any>[];
  @Output() openEntry = new EventEmitter<EntryData>();

  constructor(
    protected analyticsService: AnalyticsService
  ) {}
  
  open(e: Entry<any>) { this.openEntry.emit({ entry: e, entries: this.entries }); }
}
